export default "__VITE_ASSET__Dr53msvs__"